import { enhancedApi as generatedOnePasswordApi } from './generated/onePasswordService';

// Export the enhanced API with all endpoints
export const onePasswordApi = generatedOnePasswordApi;

// Export hooks for easy use in components
export const {
  useOnepasswordListItemsQuery,
  useOnepasswordCreateItemMutation,
  useOnepasswordGetItemQuery,
  useOnepasswordUpdateItemMutation,
  useOnepasswordDeleteItemMutation,
  useOnepasswordCreateFromUrlMutation,
  useOnepasswordGetMainCredentialsQuery,
  useOnepasswordGetUserCredentialsQuery,
} = generatedOnePasswordApi;

// Alias for backwards compatibility
export const useOnepasswordMainCredentialsQuery =
  useOnepasswordGetMainCredentialsQuery;
export const useOnepasswordUserCredentialsQuery =
  useOnepasswordGetUserCredentialsQuery;

// Type not in generated schema - define locally for conflict handling
export type OnePasswordConflictError = {
  detail?: string;
  existing_item_id?: string;
  code?: 'duplicate_main_credentials' | 'duplicate_user_credentials';
  error?: string;
};

// Re-export types for convenience
export type {
  CreateOnePasswordItemFromUrlSchema,
  CreateOnePasswordItemSchema,
  OnePasswordItemSchema,
  OnePasswordItemType,
  UpdateOnePasswordItemSchema,
} from './generated/onePasswordService';
